import { css } from 'linaria';

export const metalRoofInfoWrapper = css`
  width: 755px;
  margin-bottom: 32px;

  @media (--only-desktop) {
    width: 616px;
  }

  @media (--to-desktop) {
    width: 100%;
  }

  @media (--only-mobile) {
    margin-bottom: 24px;
  }
`;

export const metalRoofInfoText = css`
  margin-bottom: 4px; ;
`;

export const metalRoofInfoList = css`
  && {
    padding-left: 25px;
    margin-bottom: 10px;

    li {
      margin-bottom: 4px;
    }
  }
`;

export const metalRoofInfoSwiper = css`
  display: flex;

  & .swiper-wrapper {
    @media (--from-tablet) {
      align-content: flex-start;
      flex-wrap: wrap;
      gap: 24px;
    }

    @media (--only-tablet) {
      gap: 26px 40px;
    }
  }
`;

export const metalRoofProductSlide = css`
  &&& {
    display: flex;
    flex-direction: column;
    width: 176.66px;
    row-gap: 24px;

    @media (--only-desktop) {
      width: 205px;
    }

    @media (--only-tablet) {
      width: 193.33px;
    }

    @media (--only-mobile) {
      width: 204px;
      margin-right: 24px;
    }
  }
`;
